import { getListViewSettings } from '../services/SettingsServices';
import { getDefaultListViewConfig } from '../config/listViewSettingsConfig';

export function serializeListViewConfig(config) {
  return JSON.stringify({
    default_date_range: config?.default_date_range || 'current_month',
    custom_from_date: config?.custom_from_date || null,
    custom_upto_date: config?.custom_upto_date || null,
    plant_ids: [...(config?.plant_ids || [])].map(Number).sort((a, b) => a - b),
    schedule_statuses: [...(config?.schedule_statuses || [])].sort(),
    record_statuses: [...(config?.record_statuses || [])].sort(),
    customer_ids: [...(config?.customer_ids || [])].map(String).sort(),
  });
}

/**
 * Bharat Concrete-style bootstrap:
 * 1) Start settings fetch (non-blocking)
 * 2) Load list with defaults immediately so the table paints
 * 3) If saved settings differ, reload once with keepRowsVisible so the table
 *    does not return to skeletons while the refresh is in flight
 */
export async function bootstrapListViewLoad({
  cookies,
  viewKey,
  loadFn,
  isCancelled = () => false,
}) {
  const defaults = getDefaultListViewConfig(viewKey);
  const defaultKey = serializeListViewConfig(defaults);
  const settingsPromise = getListViewSettings(cookies, viewKey).catch(() => null);

  await loadFn(defaults, { keepRowsVisible: false });
  if (isCancelled()) return defaults;

  const settingsResult = await settingsPromise;
  if (isCancelled()) return defaults;

  const resolved = settingsResult?.config || defaults;
  if (serializeListViewConfig(resolved) !== defaultKey) {
    await loadFn(resolved, { keepRowsVisible: true });
  }
  return resolved;
}
